"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetVerificationOutput = void 0;
var AssetVerificationOutput;
(function (AssetVerificationOutput) {
    AssetVerificationOutput.VerificationStatusValues = [
        'Untested',
        'TextractFailed',
        'UnverifiedFailure',
        'VerifiedFailure',
        'Passed', // verification passed
    ];
    AssetVerificationOutput.CURRENT_STORED_VERIFICATION_RESULT_SCHEMA_VERSION = 1;
})(AssetVerificationOutput = exports.AssetVerificationOutput || (exports.AssetVerificationOutput = {}));
//# sourceMappingURL=AssetVerification.js.map